<form [formGroup]="siddhaYogaForm" >
    


  
  
  
  <div class="step-container">
      <ng-template #labelSix>{{ getTranslation('contemplation.title') }}</ng-template>
      <div class="step-title">
        {{ isEditable ? getTranslation('contemplation.title') : getTranslation('contemplation.blockedForEdit') }}
        <span *ngIf="!isEditable" class="badge badge-warning ml-2" style="font-size: 0.75rem;">(Read Only)</span>
      </div>
  

      <div *ngIf="isJsonShow">
        {{siddhaYogaForm.value | json}}
      </div>

      <!-- {{siddhaYogaForm.value | json}} -->


      <br>



      <!-- Main Selection Cards -->
      <div class="selection-container"  *ngIf="!isPreviewMode">
        <div class="selection-header">
          <h4 class="selection-title">{{ getTranslation('contemplation.chooseSubmissionTitle') }}</h4>
          <p class="selection-subtitle">{{ getTranslation('contemplation.chooseSubmissionSubtitle') }}</p>
        </div>
        
        <div class="submission-choice-container" *ngIf="!isPreviewMode"> 
          <div
            class="submission-card"
            [class.active]="siddhaYogaForm.get('SubmissionMode')?.value === 'form'"
            (click)="siddhaYogaForm.get('SubmissionMode')?.setValue('form')"
          >
            <div class="card-icon">
              <i class="fas fa-pencil-alt"></i>
            </div>
            <div class="card-content">
              <h5 class="card-title">{{ getTranslation('contemplation.card.form.title') }}</h5>
              <p class="card-description">{{ getTranslation('contemplation.card.form.description') }}</p>
            </div>
            <div class="card-indicator">
              <i class="fas fa-check-circle" *ngIf="siddhaYogaForm.get('SubmissionMode')?.value === 'form'"></i>
            </div>
          </div>
        
          <div 
            class="submission-card"
            [class.active]="siddhaYogaForm.get('SubmissionMode')?.value === 'file'"
            (click)="siddhaYogaForm.get('SubmissionMode')?.setValue('file')"
          >
            <div class="card-icon">
              <i class="fas fa-file-upload"></i>
            </div>
            <div class="card-content">
              <h5 class="card-title">{{ getTranslation('contemplation.card.file.title') }}</h5>
              <p class="card-description">{{ getTranslation('contemplation.card.file.description') }}</p>
            </div>
            <div class="card-indicator">
              <i class="fas fa-check-circle" *ngIf="siddhaYogaForm.get('SubmissionMode')?.value === 'file'"></i>
            </div>
          </div>
        </div>
      </div>
      



    
      <ng-container *ngIf="siddhaYogaForm.get('SubmissionMode')?.value === 'form'">
   

      <div class="alert-box">
        <div class="alert-title">
          <i class="fas fa-info-circle" [nbTooltip]="getTranslation('contemplation.tooltip')" nbTooltipPlacement="top"></i>
          &nbsp; {{ getTranslation('contemplation.alert.title') }}
        </div>
        <div class="alert-text">
          <p>
            {{ getTranslation('contemplation.alert.intro') }}
          </p>
          <p>{{ getTranslation('contemplation.alert.demonstrate') }}</p>
          <ul>
            <li>{{ getTranslation('contemplation.alert.point1') }}</li>
            <li>{{ getTranslation('contemplation.alert.point2') }}</li>
            <li>{{ getTranslation('contemplation.alert.point3') }}</li>
          </ul>
        </div>
      </div>
      



    
      <br>

   


      <div class="form-wrapper mt-3">
        <!-- Question 1 -->
        <div class="form-section mb-4 shadow-sm">
          <div class="section-header">
            <div class="q-badge">1</div>
            <div class="section-title">
              {{ getTranslation('contemplation.q1.title') || getTranslation('contemplation.q1a.label') }}
            </div>
          </div>

          <label class="sub-label" for="TeachingsPracticeInDetails">{{ getTranslation('contemplation.q1a.label') }}</label>
          <textarea
            class="form-control custom-textarea mb-2"
            id="TeachingsPracticeInDetails"
            formControlName="TeachingsPracticeInDetails"
            rows="5"
            [placeholder]="getTranslation('contemplation.answerPlaceholder')"
            maxlength="5000"
            #teachingsTextarea
            (input)="updateLetterCount('TeachingsPracticeInDetails', teachingsTextarea.value)"
          ></textarea>

          <span class="error-text" *ngIf="submitted && siddhaYogaForm.get('TeachingsPracticeInDetails')?.invalid">
            <span *ngIf="siddhaYogaForm.get('TeachingsPracticeInDetails')?.errors?.['required']">{{ getTranslation('validation.requiredField') }}</span>
            <span *ngIf="siddhaYogaForm.get('TeachingsPracticeInDetails')?.errors?.['minlength']">{{ getTranslation('validation.minLength100') }}</span>
            <span *ngIf="siddhaYogaForm.get('TeachingsPracticeInDetails')?.errors?.['maxlength']">{{ getTranslation('validation.maxLength1000') }}</span>
          </span>

          <div class="d-flex justify-content-end align-items-center gap-2">
            <span class="counter">{{ getCharacterCount('TeachingsPracticeInDetails') }} / 5000</span>
          </div>

          <hr class="my-4">

          <label class="sub-label" for="WebsitePracticeInDetails">{{ getTranslation('contemplation.q1b.label') }}</label>
          <textarea
            class="form-control custom-textarea mb-2"
            id="WebsitePracticeInDetails"
            formControlName="WebsitePracticeInDetails"
            rows="5"
            [placeholder]="getTranslation('contemplation.answerPlaceholder')"
            maxlength="5000"
            #websiteTextarea
            (input)="updateLetterCount('WebsitePracticeInDetails', websiteTextarea.value)"
          ></textarea>
          <div class="d-flex justify-content-end align-items-center gap-2">
            <span class="counter">{{ getCharacterCount('WebsitePracticeInDetails') }} / 5000</span>
            <span class="error-text" *ngIf="submitted && siddhaYogaForm.get('WebsitePracticeInDetails')?.invalid">
              <span *ngIf="siddhaYogaForm.get('WebsitePracticeInDetails')?.errors?.['required']">{{ getTranslation('validation.requiredField') }}</span>
              <span *ngIf="siddhaYogaForm.get('WebsitePracticeInDetails')?.errors?.['minlength']">{{ getTranslation('validation.minLength100') }}</span>
              <span *ngIf="siddhaYogaForm.get('WebsitePracticeInDetails')?.errors?.['maxlength']">{{ getTranslation('validation.maxLength1000') }}</span>
            </span>
          </div>
        </div>

        <!-- Question 2 -->
        <div class="form-section mb-4 shadow-sm">
          <div class="section-header">
            <div class="q-badge">2</div>
            <div class="section-title">
              {{ getTranslation('contemplation.q2.intro') }}
            </div>
          </div>

          <label class="sub-label" for="TeachingsPracticeBenifitsInDetails">{{ getTranslation('contemplation.q2a.label') }}</label>
          <textarea
            class="form-control custom-textarea mb-2"
            id="TeachingsPracticeBenifitsInDetails"
            formControlName="TeachingsPracticeBenifitsInDetails"
            rows="4"
            [placeholder]="getTranslation('contemplation.answerPlaceholder')"
            maxlength="5000"
            #benefit1Textarea
            (input)="updateLetterCount('TeachingsPracticeBenifitsInDetails', benefit1Textarea.value)"
          ></textarea>



          <span class="error-text" *ngIf="submitted && siddhaYogaForm.get('TeachingsPracticeBenifitsInDetails')?.invalid">
            <span *ngIf="siddhaYogaForm.get('TeachingsPracticeBenifitsInDetails')?.errors?.['required']">{{ getTranslation('validation.requiredField') }}</span>
            <span *ngIf="siddhaYogaForm.get('TeachingsPracticeBenifitsInDetails')?.errors?.['minlength']">{{ getTranslation('validation.minLength100') }}</span>
            <span *ngIf="siddhaYogaForm.get('TeachingsPracticeBenifitsInDetails')?.errors?.['maxlength']">{{ getTranslation('validation.maxLength1000') }}</span>
          </span>


          <div class="d-flex justify-content-end align-items-center gap-2">
            <span class="counter">{{ getCharacterCount('TeachingsPracticeBenifitsInDetails') }} / 5000</span>
          </div>

          <label class="sub-label mt-3" for="WebsitePracticeBenifitsInDetails">{{ getTranslation('contemplation.q2b.label') }}</label>
          <textarea
            class="form-control custom-textarea mb-2"
            id="WebsitePracticeBenifitsInDetails"
            formControlName="WebsitePracticeBenifitsInDetails"
            rows="4"
            [placeholder]="getTranslation('contemplation.answerPlaceholder')"
            maxlength="5000"
            #benefit2Textarea
            (input)="updateLetterCount('WebsitePracticeBenifitsInDetails', benefit2Textarea.value)"
          ></textarea>


          <span class="error-text" *ngIf="submitted && siddhaYogaForm.get('WebsitePracticeBenifitsInDetails')?.invalid">
            <span *ngIf="siddhaYogaForm.get('WebsitePracticeBenifitsInDetails')?.errors?.['required']">{{ getTranslation('validation.requiredField') }}</span>
            <span *ngIf="siddhaYogaForm.get('WebsitePracticeBenifitsInDetails')?.errors?.['minlength']">{{ getTranslation('validation.minLength100') }}</span>
            <span *ngIf="siddhaYogaForm.get('WebsitePracticeBenifitsInDetails')?.errors?.['maxlength']">{{ getTranslation('validation.maxLength1000') }}</span>
          </span>


          <div class="d-flex justify-content-end align-items-center gap-2">
            <span class="counter">{{ getCharacterCount('WebsitePracticeBenifitsInDetails') }} / 5000</span>
           
          

          </div>
        </div>

        <!-- Question 3 -->
        <div class="form-section mb-4 shadow-sm">
          <div class="section-header">
            <div class="q-badge">3</div>
            <div class="section-title">
              {{ getTranslation('contemplation.q3.label') }}
            </div>
          </div>

          <textarea
            class="form-control custom-textarea mb-2"
            id="AppliedQualitiesInSeva"
            formControlName="AppliedQualitiesInSeva"
            rows="5"
            [placeholder]="getTranslation('contemplation.answerPlaceholder')"
            maxlength="5000"
            #sevaWorkTextarea
            (input)="updateLetterCount('AppliedQualitiesInSeva', sevaWorkTextarea.value)"
          ></textarea>


          <span class="error-text" *ngIf="submitted && siddhaYogaForm.get('AppliedQualitiesInSeva')?.invalid">
            <span *ngIf="siddhaYogaForm.get('AppliedQualitiesInSeva')?.errors?.['required']">{{ getTranslation('validation.requiredField') }}</span>
            <span *ngIf="siddhaYogaForm.get('AppliedQualitiesInSeva')?.errors?.['minlength']">{{ getTranslation('validation.minLength100') }}</span>
            <span *ngIf="siddhaYogaForm.get('AppliedQualitiesInSeva')?.errors?.['maxlength']">{{ getTranslation('validation.maxLength1000') }}</span>
          </span>

          <div class="d-flex justify-content-end align-items-center gap-2">
            <span class="counter">{{ getCharacterCount('AppliedQualitiesInSeva') }} / 5000</span>
          </div>
        </div>

        <!-- Question 4 -->
        <div class="form-section mb-4 shadow-sm">
          <div class="section-header">
            <div class="q-badge">4</div>
            <div class="section-title">
              {{ getTranslation('contemplation.q4.label') }}
            </div>
          </div>

          <textarea
            class="form-control custom-textarea mb-2"
            id="DailyScheduleDetails"
            formControlName="DailyScheduleDetails"
            rows="5"
            [placeholder]="getTranslation('contemplation.answerPlaceholder')"
            maxlength="5000"
            #scheduleTextarea
            (input)="updateLetterCount('DailyScheduleDetails', scheduleTextarea.value)"
          ></textarea>


          <span class="error-text" *ngIf="submitted && siddhaYogaForm.get('DailyScheduleDetails')?.invalid">
            <span *ngIf="siddhaYogaForm.get('DailyScheduleDetails')?.errors?.['required']">{{ getTranslation('validation.requiredField') }}</span>
            <span *ngIf="siddhaYogaForm.get('DailyScheduleDetails')?.errors?.['minlength']">{{ getTranslation('validation.minLength100') }}</span>
            <span *ngIf="siddhaYogaForm.get('DailyScheduleDetails')?.errors?.['maxlength']">{{ getTranslation('validation.maxLength1000') }}</span>
          </span>

          <div class="d-flex justify-content-end align-items-center gap-2">
            <span class="counter">{{ getCharacterCount('DailyScheduleDetails') }} / 5000</span>
           
          </div>
        </div>

        <!-- Question 5 -->
        <div class="form-section shadow-sm">
          <div class="section-header">
            <div class="q-badge">5</div>
            <div class="section-title">
              {{ getTranslation('contemplation.q5.label') }}
            </div>
          </div>

          <textarea
            class="form-control custom-textarea mb-2"
            id="SevaBenifitForTeachings"
            formControlName="SevaBenifitForTeachings"
            rows="5"
            [placeholder]="getTranslation('contemplation.answerPlaceholder')"
            maxlength="5000"
            #sevaTeachingsTextarea
            (input)="updateLetterCount('SevaBenifitForTeachings', sevaTeachingsTextarea.value)"
          ></textarea>


          <span class="error-text" *ngIf="submitted && siddhaYogaForm.get('SevaBenifitForTeachings')?.invalid">
            <span *ngIf="siddhaYogaForm.get('SevaBenifitForTeachings')?.errors?.['required']">{{ getTranslation('validation.requiredField') }}</span>
            <span *ngIf="siddhaYogaForm.get('SevaBenifitForTeachings')?.errors?.['minlength']">{{ getTranslation('validation.minLength100') }}</span>
            <span *ngIf="siddhaYogaForm.get('SevaBenifitForTeachings')?.errors?.['maxlength']">{{ getTranslation('validation.maxLength1000') }}</span>
          </span>


          <div class="d-flex justify-content-end align-items-center gap-2">
            <span class="counter">{{ getCharacterCount('SevaBenifitForTeachings') }} / 5000</span>
            
          </div>
        </div>
      </div>

      <!-- <p>
        I understand Ashram Dharma and I will abide by the Ashram Daily Schedule on an ongoing basis for the duration of my ashram stay _____ [Sign Off by writing name.]
      </p> -->

    </ng-container>



    <ng-container *ngIf="siddhaYogaForm.get('SubmissionMode')?.value === 'file'">
      <!-- Generic Document Upload Component -->
      <div class="row gx-2 mt-4">
        <div class="form-group col-12 mb-3">
          <app-addendum-document-upload
            [config]="documentUploadConfig"
            [showValidationError]="documentSectionSubmitted"
            [isPreviewMode]="isPreviewMode"
            (documentsChange)="onDocumentsChange($event)"
            (validationChange)="onValidationChange($event)">
          </app-addendum-document-upload>
        </div>
      </div>
    </ng-container>
    </div>

      <!-- Buttons -->
    <!-- Buttons start -->
  <div class="btn-group vendortitle nb-progress-bar margincss mobile-responsive" 
       *ngIf="!isPreviewMode && isEditable">
    <button type="button" class="btn savedraftbtn" 
            *ngIf="siddhaYogaForm.get('SaveMode')?.value !== SaveMode.SAVE"
            (click)="onSubmit(SaveMode.DRAFT)">
      <i class="fas fa-save mr-2"></i>{{ getTranslation('button.saveAsDraft') }}
    </button>
    <button type="button" class="btn prevbtn" (click)="goToBack()">
      <i class="fas fa-arrow-left mr-2"></i>{{ getTranslation('button.previous') }}
    </button>
    <button type="button" class="btn nextbtn" (click)="onSubmit(SaveMode.SAVE)">
      <i class="fas fa-arrow-right mr-2"></i>{{ getTranslation('button.next') }}
    </button>
  </div>
  <!-- Buttons ends -->
  </form>
  